export default {
  text: 'Skip',
};
